var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"margin-top",attrs:{"id":"demo-basic-card"}},[_c('div',{attrs:{"id":"dashboard-analytics"}},[_c('account-overview'),_c('package-register')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }